/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAssignmentUser } from './InternalApiAssignmentUser';
import {
    InternalApiAssignmentUserFromJSON,
    InternalApiAssignmentUserFromJSONTyped,
    InternalApiAssignmentUserToJSON,
    InternalApiAssignmentUserToJSONTyped,
} from './InternalApiAssignmentUser';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * Alert status update event
 * @export
 * @interface InternalApiAlertStatusEvent
 */
export interface InternalApiAlertStatusEvent {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertStatusEvent
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertStatusEvent
     */
    alertId?: number;
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiAlertStatusEvent
     */
    alertType?: InternalApiAlertType;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertStatusEvent
     */
    statusId?: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiAlertStatusEvent
     */
    startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiAlertStatusEvent
     */
    endTime?: Date;
    /**
     * 
     * @type {InternalApiAssignmentUser}
     * @memberof InternalApiAlertStatusEvent
     */
    assigner?: InternalApiAssignmentUser;
}



/**
 * Check if a given object implements the InternalApiAlertStatusEvent interface.
 */
export function instanceOfInternalApiAlertStatusEvent(value: object): value is InternalApiAlertStatusEvent {
    return true;
}

export function InternalApiAlertStatusEventFromJSON(json: any): InternalApiAlertStatusEvent {
    return InternalApiAlertStatusEventFromJSONTyped(json, false);
}

export function InternalApiAlertStatusEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertStatusEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'alertId': json['alertId'] == null ? undefined : json['alertId'],
        'alertType': json['alertType'] == null ? undefined : InternalApiAlertTypeFromJSON(json['alertType']),
        'statusId': json['statusId'] == null ? undefined : json['statusId'],
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'assigner': json['assigner'] == null ? undefined : InternalApiAssignmentUserFromJSON(json['assigner']),
    };
}

export function InternalApiAlertStatusEventToJSON(json: any): InternalApiAlertStatusEvent {
    return InternalApiAlertStatusEventToJSONTyped(json, false);
}

export function InternalApiAlertStatusEventToJSONTyped(value?: InternalApiAlertStatusEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'alertId': value['alertId'],
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
        'statusId': value['statusId'],
        'startTime': value['startTime'] == null ? value['startTime'] : value['startTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
        'assigner': InternalApiAssignmentUserToJSON(value['assigner']),
    };
}

